module.exports = __webpack_public_path__ + "img/logout.74566179.svg";